import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
    DxAccordionModule,
    DxButtonModule, DxColorBoxModule,
    DxFileUploaderModule,
    DxFormModule, DxLoadIndicatorModule,
    DxPopupModule, DxSelectBoxModule, DxTagBoxModule,
    DxTemplateModule,
    DxTextBoxModule, DxValidatorModule
} from 'devextreme-angular';
import {CssTemplateDto, TenantOption} from '../../model/Theme';
import {finalize, of, switchMap} from 'rxjs';
import notify from 'devextreme/ui/notify';
import {CssTemplateService} from '../../services/css-template-service';
import {CssTemplateVersionsComponent} from "../css-template-versions/css-template-versions.component";
import {CssTemplateEditor} from "../css-template-editor/css-template-editor";
import {TenantService} from "../../services/tenant-service";
import {ReportType} from "../../model/ReportType";

@Component({
  selector: 'add-edit-css-component',
    imports: [
        DxFormModule,
        DxFileUploaderModule,
        DxPopupModule,
        DxButtonModule,
        DxAccordionModule,
        DxTemplateModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxColorBoxModule,
        DxLoadIndicatorModule,
        DxSelectBoxModule,
        CssTemplateVersionsComponent,
        CssTemplateEditor,
        DxTagBoxModule,
    ],
  templateUrl: './add-edit-css-component.html',
  styleUrl: './add-edit-css-component.scss'
})
export class AddEditCssComponent implements OnInit {
  @Input() visible!: boolean;
  @Input() template!: CssTemplateDto;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Output() onFinished = new EventEmitter<boolean>();

  _template: CssTemplateDto = {} as CssTemplateDto;
  showIndicator: boolean = false;
  showVersions: boolean = false;
  reportTypes: string[] = ["ALL", ...Object.values(ReportType)];
  tenants: TenantOption[] = [];

  initialBody = ".mdfm-top.mdfm-heading { border-bottom: solid 1px #000000; text-align: center; }\n\n.mdfm-data { text-align: right; }";

  constructor(private cssTemplateService: CssTemplateService,
              private tenantService: TenantService) {}

  ngOnInit() {
    if (!this.template || !this.template.id) this.template =  {
        id: null,
        name: "New Template",
        reportType: ["ALL"],
        tenant: ["ALL"],
        body: this.initialBody
    }
    this._template = this.template;
    this.tenantService.getTenantList()
          .subscribe(tenantList => {
              this.tenants = [{displayName: "ALL", value: "ALL"}, ...Object.values(tenantList)];
          });
  }

    onTenantChange(e: any) {
        this.onListWithAllChange(e, "tenant");
    }

    onReportTypeChange(e: any) {
        this.onListWithAllChange(e, "reportType");
    }

    onListWithAllChange(e: any, propertyName: string) {
        if (!this.template) return;

        const newValue: string[] = e.value || [];
        const previousValue: string[] = e.previousValue || [];

        // if "ALL" was just added, keep only "ALL"
        if (newValue.includes("ALL") && !previousValue.includes("ALL")) {
            (this.template as any)[propertyName] = ["ALL"];
        }
        // if another option was added while "ALL" is selected, remove "ALL"
        else if (newValue.includes("ALL") && newValue.length > 1) {
            (this.template as any)[propertyName] = newValue.filter((t: string) => t !== "ALL");
        }
        else {
            (this.template as any)[propertyName] = newValue;
        }
    }

  saveEditor(e: Event) {
      e.preventDefault();
      this.showIndicator = true;

      if (!this.template.id) {
          this.cssTemplateService.create(this._template)
              .pipe(
                  switchMap(res => {
                      this.onFinished.emit(true);
                      notify("CSS Template created.", "success", 2000)
                      return of(false);
                  }),
                  finalize(() => this.showIndicator = false)
              )
              .subscribe(response => {});
      } else {
          this.cssTemplateService.update(this._template)
              .pipe(
                  switchMap(res => {
                      this.onFinished.emit(true);
                      notify("CSS Template updated.", "success", 2000)
                      return of(false);
                  }),
                  finalize(() => this.showIndicator = false)
              )
              .subscribe(response => {});
      }
  }

  codeUpdated(updatedCode: string) {
    this._template.body = updatedCode;
  }

  onVisibleChange(newValue: boolean) {
    this.visible = newValue;
    this.visibleChange.emit(this.visible);
  }

  disableVersion() {
    this.showVersions = false;
  }

  restoreVersion($event: any) {
    this._template.body = $event.version.content;
    this.showVersions = false;
  }

  canBeSaved(): boolean {
    return !(this._template.name && this._template.reportType?.length && this._template.tenant?.length);
  }

}
